/**
 * Brand wordmark. Serif "injury.help" with an ember dot, square mark, optional
 * sub-line (e.g., "Personal injury directory") underneath.
 *
 *   <Wordmark />
 *   <Wordmark size={28} sub="Personal injury directory" />
 */

export interface WordmarkProps {
    size?: number;
    sub?: string;
    className?: string;
}

export function Wordmark({ size = 22, sub, className }: WordmarkProps) {
    const cls = ['inline-flex items-center gap-2 text-ink', className ?? '']
        .filter(Boolean)
        .join(' ');

    return (
        <span className={cls}>
            <svg
                width={size + 4}
                height={size + 4}
                viewBox="0 0 28 28"
                fill="none"
                aria-hidden="true"
            >
                <rect
                    x="1.5"
                    y="1.5"
                    width="25"
                    height="25"
                    rx="6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
                <path
                    d="M9 18V8M14 18V8M19 18V13a3 3 0 0 0-3-3"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="14" cy="21" r="1" className="fill-ember" />
            </svg>
            <span className="leading-none">
                <span
                    className="font-serif font-medium tracking-tight block"
                    style={{ fontSize: size }}
                >
                    injury<span className="text-ember">.</span>help
                </span>
                {sub !== undefined && (
                    <span className="block font-sans text-[10px] uppercase tracking-widest text-ink-mute mt-0.5">
                        {sub}
                    </span>
                )}
            </span>
        </span>
    );
}

export default Wordmark;
